import React, { memo } from 'react';
import { TableBody } from '@mui/material';
import { EmptyState, LoadingState } from '../TableStates/TableStates';
import ViolationRow from '../ViolationRows/ViolationRow';
import TablePaginationComponent from '../TablePagination/TablePagination';
import { selectSelectedViolationId } from '../../../redux/violationsReport/violationsReportSlice';
import { useSelector } from 'react-redux';

/**
 * Main component for the violation table content */
const ViolationsTableContent = ({
  isLoading,
  sortedViolations = [],
  tableColumnsCount,
  onViolationClick,
  // Props for pagination
  totalCount,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  isPaginated = true,
}) => {
  const selectedViolationId = useSelector(selectSelectedViolationId);
  // Show the charging status
  if (isLoading) {
    return <LoadingState tableColumnsCount={tableColumnsCount} />;
  }

  // show empty state
  if (sortedViolations.length === 0) {
    return <EmptyState tableColumnsCount={tableColumnsCount} />;
  }

  // Render the table content
  return (
    <TableBody>
      {/* Map violations to table rows */}
      {sortedViolations.map((violation) => (
        <ViolationRow
          key={violation.id}
          violation={violation}
          onViolationClick={onViolationClick}
          isSelected={selectedViolationId === violation.id}
        />
      ))}

      {/* Show pagination if enabled */}
      {isPaginated && (
        <TablePaginationComponent
          totalCount={totalCount || sortedViolations.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={onPageChange}
          onRowsPerPageChange={onRowsPerPageChange}
          tableColumnsCount={tableColumnsCount}
        />
      )}
    </TableBody>
  );
};

export default memo(ViolationsTableContent);
